
import { defineComponent, ref, Ref, computed } from 'vue';

import { useToast } from "vue-toastification";
import { default as useConfig, reset_config } from '@/composables/useConfig';

import Papa from 'papaparse';

export default defineComponent({

	setup() {

		const config = useConfig()
		const toast = useToast()

		const html_file_dataset = ref(null) as Ref<HTMLInputElement | null>
		const html_file_model = ref(null) as Ref<HTMLInputElement | null>

		const get_file_from_event = (e: Event): File | null => {

			const target = <HTMLInputElement>e.target

			if (target == null || target.files == null || target.files.length !== 1) { // last condition limits 1 upload per
				return null;
			}

			const file = target.files[0];
			return file;

		}

		const file_changed_dataset = (e: Event) => {
			reset_config(config, {model: false});
			parse_dataset_progress.value = null;

			config.dataset.file = get_file_from_event(e);
		}
        const file_changed_model = (e: Event) => {
			reset_config(config, {dataset: false});
			parse_dataset_progress.value = null;

            config.model.file = get_file_from_event(e);
        }

		const file_clear_dataset = () => {
			if(html_file_dataset.value != null)
				html_file_dataset.value.value = "";
			
			config.dataset.file = null;
			parse_dataset_progress.value = null
		}
		const file_clear_model = () => {
			if(html_file_model.value != null)
				html_file_model.value.value = "";

			config.model.file = null;
			parse_model_progress.value = null
		}

		const parse_dataset_progress = ref(null) as Ref<number | null>
		const parse_dataset = (then: () => void) => {
			if (config.dataset.file !== null)
			{
				if (parse_dataset_progress.value == 100)
				{
					then()
					return
				}
				
				parse_dataset_progress.value = 0;

				let dataset_file_size = config.dataset.file.size;
				let all_errors: Papa.ParseError[][] = [];
				let all_data: string[][] = [];
				// let first_rows: string[][] = [];

				Papa.parse(config.dataset.file, {
					step: function(results) {
						parse_dataset_progress.value = (results.meta.cursor / dataset_file_size) * 100
						
						config.dataset.amount_rows += 1;

						if (results.errors.length > 0)
						{
							all_errors.push(results.errors)
						}

						if (config.dataset.amount_rows < 4)
						{
							config.dataset.data_first_rows.push(results.data as string[])
							// console.log("steprow", results.data as string[])
						}

						if (!config.dataset.read_as_stream)
							all_data.push(results.data as string[]) 
						// console.log(`Progress: ${parse_dataset_progress.value}%`)
					},
					error: (err, file) => {
						// console.log("ERROR:", err, file);
						// parse_dataset_progress.value;
						toast(`Failed parasing input dataset ${file?.name}`)
						toast(`Error: ${err.message}`)
						parse_dataset_progress.value = null
						return;
					},
					complete: (results) => {
						// console.log(results)
						// if (!config.dataset.read_as_stream && results.data.length > 0)
						// 	config.dataset.data = results.data;
						
						parse_dataset_progress.value = 100
						if (results.errors.length > 0)
						{
							toast(`Dataset parsed with errors`)
							parse_dataset_progress.value = null
						}
						if (all_errors.length > 0)
						{
							toast(`Dataset parsed, but some rows (${all_errors.length}) contain errors`)
							console.log(all_errors);
							parse_dataset_progress.value = null
						}
						else if (config.dataset.amount_rows < 2)
						{
							toast('Dataset need to have atleast 2 rows.')
							parse_dataset_progress.value = null
						}
						else
						{
							toast.success(`Dataset parsed succesfully`)

							if (!config.dataset.read_as_stream)
							{
								config.dataset.data_parsed_raw = all_data
								// console.log(config.dataset.data_parsed_raw)
							}

							// console.log("PARSE COMPLETED: ", config.dataset)

							then()
						}

					}
				});


			}
		}
		
		const parse_model_progress = ref(null) as Ref<number | null>
		const parse_model = () => {
			return false;
		}

		const page_next_disabled = computed( () => false )

		const dataset_stream_recommendation_bytes = 20 * 1000; // *1000^1 = kB, *1000^2 = MB, etc...
		

		return {

			config,

			file_changed_dataset,
			file_changed_model,

			file_clear_dataset,
			file_clear_model,

			parse_dataset_progress,
			parse_dataset,
			parse_model_progress,
			parse_model,

			page_next_disabled,

			dataset_stream_recommendation_bytes,

			toast
			
		}
	
	},

});
